import { useFilters } from "core/features/filters/store";
import { AdvancedFiltersProps } from "../components/concentracao-colheita";

const useAdvancedFiltersIdadeTalhao = () => {
  const { updateFiltroIdadeDoTalhao, filters } = useFilters();
  const { filtroIdadeDoTalhao } = filters;

  const filterSafraPeriodos = filtroIdadeDoTalhao?.safraPeriodos;

  const applyFilters = (
    advancedFilters: AdvancedFiltersProps,
    handleCloseModal: () => void
  ) => {
    updateFiltroIdadeDoTalhao(
      {
        safraPeriodos: advancedFilters.safraPeriodos,
      },
      true
    );
    handleCloseModal();
  };

  const clearFilters = (
    handleResetFiltersState: (advancedFilters: AdvancedFiltersProps) => void
  ) => {
    updateFiltroIdadeDoTalhao(
      {
        safraPeriodos: [],
      },
      true
    );
    handleResetFiltersState({
      safraPeriodos: [],
    });
  };

  return {
    items: {
      filterSafraPeriodos,
    },
    onChange: applyFilters,
    clearFilters,
  };
};

export default useAdvancedFiltersIdadeTalhao;
